export default __webpack_public_path__ + "static/media/icon-value-Advancements.1addaa8c.svg";